import loadable from "@loadable/component";
import CreateIcon from "../../Icons/Create";
import APIS from "../../constant/EndPoint";
import { useParams } from "react-router";
import usePatchHook from "../../customHooks/usePatchHook";
import useGetHook from "../../customHooks/useGetHook";
import Spinner from "../../components/Reusable/Spinner";
import CreateCustomer from "../../components/Order/CreateCustomerForm";
import Modal from "../../components/Reusable/Modal";
import { useState } from "react";
import usePostHook from "../../customHooks/usePostHook";
import { toast } from "react-toastify";

const EditMerchantComponent = loadable(
  () => import("../../components/Merchant/EditMerchant")
);
const EditMerchant = () => {
  const { id } = useParams()
  const [openAddReceiverPopup, setOpenAddReceiverPopup] = useState(false)
  const [openAddSenderPopup, setOpenAddSenderPopup] = useState(false)

  const { data: merchant, refetch, isLoading } = useGetHook({
    queryKey: [`merchant-${id}`],
    url: `${APIS.MERCHANT}${id}/`,
    params: {},
  });

  const { data: branchContactData, isLoading: branchContactDataLoading } = useGetHook({
    queryKey: [`merchant-${id}-branch-contact-data`],
    url: `${APIS.MERCHANT}${id}/customer-branch-wise-contact/`,
    params: {},
  });


  const { data: cityContactData, isLoading: cityContactDataLoading } = useGetHook({
    queryKey: [`merchant-${id}-city-contact-data`],
    url: `${APIS.MERCHANT}${id}/customer-city-wise-contact/`,
    params: {},
  });


  const { mutateAsync: mutateCustomerContactCreateUpdate, } = usePostHook({
    queryKey: ["merchant", `merchant-${id}`, `merchant-${id}-branch-contact-data`, `merchant-${id}-city-contact-data`],
    navigateURL: "",
  });

  const handleUpdateContact = async (contact: string, itemId: string, branch:boolean, city:boolean) => {
    if (!contact) {
      return
    }
    const url = `${APIS.CUSTOMER}update-customer-contact/`;
    let formData = {
      contact: contact
    };
    if (branch && merchant?.default_sender?.id) {
      formData["branch"] = itemId
      formData["customer"] = merchant?.default_sender?.id
    } else if (city && merchant?.default_receiver?.id) {
      formData["destination"] = itemId
      formData["customer"] = merchant?.default_receiver?.id
    } else {
      toast.error(!merchant?.default_sender?.id ? "Default sender is required" : !merchant?.default_receiver?.id ? "Default receiver is required" : "Some value is missing")
    }
    try {
      await mutateCustomerContactCreateUpdate({ url, formData });
    } catch (err) {
      console.log(err);
    }
  }



  const { mutateAsync, isLoading: isPatchLoading } = usePatchHook({
    queryKey: ["merchant", `merchant-${id}`],
    navigateURL: "/merchant",
  });

  const handleEdit = async (values: any, setError: any) => {
    const url = `${APIS.MERCHANT}${id}/`;
    let formData = {
      ...values,
      "service_type": values?.service_type ? values?.service_type?.map((item: any, index: number) => (item?.value)) : [],
      "product_type": values?.product_type ? values?.product_type?.map((item: any, index: number) => (item?.value)) : [],
      "service_city": values?.service_city ? values?.service_city?.map((item: any, index: number) => (item?.value)) : [],
      "service_branch": values?.service_branch ? values?.service_branch?.map((item: any, index: number) => (item?.value)) : [],
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  const { mutateAsync: createCustomerMutateAsync, isPostLoading: createCustomerLoading } = usePostHook({
    queryKey: ["customers"],
    navigateURL: null,
  });

  const handleCreateCustomer = async (values: any, setError: any) => {
    const url = `${APIS.CUSTOMER}`;
    let formData = {
      ...values,
      "primary_contact": `+977${values?.mobile_number}`,
      "secondary_contact": values?.secondary_contact ? `+977${values?.secondary_contact}` : `+977${values?.mobile_number}`
    };
    try {
      const res = await createCustomerMutateAsync({ url, formData, setError });
      if (res.status === 201) {
        setOpenAddReceiverPopup(false)
        setOpenAddSenderPopup(false)
      }
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <CreateIcon />
        <span className="text-[#5E5757] font-bold text-xl">Edit Merchant ({merchant?.name}) </span>
      </div>
      {isLoading || branchContactDataLoading || cityContactDataLoading ? <Spinner /> :
        <EditMerchantComponent
          isLoading={isPatchLoading}
          handleEdit={handleEdit}
          profile={merchant}
          refetch={refetch}
          openAddReceiverPopup={openAddReceiverPopup}
          setOpenAddReceiverPopup={setOpenAddReceiverPopup}
          openAddSenderPopup={openAddSenderPopup}
          setOpenAddSenderPopup={setOpenAddSenderPopup}
          branchContactData={branchContactData}
          cityContactData={cityContactData}
          handleUpdateContact={handleUpdateContact}
        />
      }
      <Modal
        isOpen={openAddReceiverPopup}
        setIsOpen={setOpenAddReceiverPopup}
        title={"Craeate Receiver"}
        children={<>
          <CreateCustomer
            handleCreate={handleCreateCustomer}
            isLoading={createCustomerLoading}
          />
        </>} />
      <Modal
        isOpen={openAddSenderPopup}
        setIsOpen={setOpenAddSenderPopup}
        title={"Create Sender"}
        children={<>
          <CreateCustomer
            handleCreate={handleCreateCustomer}
            isLoading={createCustomerLoading}
          />
        </>} />

    </>
  );
};
export default EditMerchant;
